import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { NavDropdown, Button, Dropdown, DropdownButton, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
//api
import { getHelpText } from 'api/company';
//slices
import { userSelector } from 'slices/user';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
// components
import LanguageSwitcher from 'components/navbar/LanguageSwitcher';

const NavBarSecondary = ({ isSticky, isDesktop, activeKey }) => {
  const { t, i18n } = useTranslation(['header', 'backoffice', 'feedbackstatus']);
  const currentLang = i18n.language;
  const { isWorker } = useSelector(userSelector);
  const [helpTextList, setHelpTextList] = useState([]);
  const navigate = useNavigate();
  const { assignedLibrary } = useAssignedLibrary();

  const getHelpTextList = async () => {
    const response = await getHelpText();
    if (response?.status === 200) {
      setHelpTextList(response?.data?.results);
    }
  };

  useEffect(() => {
    getHelpTextList();
  }, []);

  const handleAdminRedirect = () => {
    localStorage.removeItem('activeAccordionKey');
    navigate('/intranet');
  };

  return (
    <div id="info-bar" className={`container-fluid ${isSticky ? 'd-none' : 'd-block'}`}>
      <div className="desktop-info container-fluid container-responsive align-items-center">
        <Col md={6} className={`d-flex px-0 ${!isDesktop && 'flex-column'}`}>
          {isDesktop ? (
            <ul className="desktop-info__items">
              <DropdownButton id="dropdown-list-button" as="li" title={t('ayuda')}>
                <Dropdown.Item
                  as={Link}
                  to={`/${assignedLibrary}/faqs`}
                  className={activeKey === '/faqs' ? 'help-item active' : 'help-item'}
                >
                  {t('faqs.faqsTitle', { ns: 'backoffice' })}
                </Dropdown.Item>
                {helpTextList.map((helpText, index) => {
                  const localizedTitle = helpText[`title_${currentLang}`] || helpText.title;
                  const localizedSlug = helpText[`slug_${currentLang}`] || helpText.slug;
                  return (
                    <Dropdown.Item
                      as={Link}
                      key={`ayuda-${index}`}
                      className={
                        activeKey === `/ayuda/${helpText.id}/${localizedSlug}` ? 'help-item active' : 'help-item'
                      }
                      to={`/${assignedLibrary}/ayuda/${helpText.id}/${localizedSlug || ''}`}
                    >
                      {localizedTitle}
                    </Dropdown.Item>
                  );
                })}
              </DropdownButton>
              <li>
                <Link to={`/${assignedLibrary}/contacto`} className={activeKey === '/contacto' ? 'active' : ''}>
                  {t('contacto')}
                </Link>
              </li>
              <li>
                <Link to={`/${assignedLibrary}/sobre-nosotros`} className={activeKey === '/sobre-nosotros' && 'active'}>
                  {t('nosotros')}
                </Link>
              </li>
              <li>
                <Link to={`/${assignedLibrary}/tarjeta-regalo`} className={activeKey === '/tarjeta-regalo' && 'active'}>
                  {t('tarjetaRegalo')}
                </Link>
              </li>
            </ul>
          ) : (
            <DropdownButton
              id="dropdown-info-mobile"
              title={t('info', { ns: 'feedbackstatus' })}
              className="mobile-info w-100 my-0"
            >
              <NavDropdown title={t('ayuda')} className="help-item dropdown-help dropdown-item">
                <NavDropdown.Item
                  as={Link}
                  to={`/${assignedLibrary}/faqs`}
                  key={'/faqs'}
                  className={activeKey === '/faqs' ? 'help-item active' : 'help-item'}
                  eventKey={'/faqs'}
                >
                  {t('faqs.faqsTitle', { ns: 'backoffice' })}
                </NavDropdown.Item>
                {helpTextList?.length > 0 &&
                  helpTextList.map((helpText, index) => {
                    const localizedTitle = helpText[`title_${currentLang}`] || helpText.title;
                    const localizedSlug = helpText[`slug_${currentLang}`] || helpText.slug;
                    return (
                      <NavDropdown.Item
                        as={Link}
                        className={
                          activeKey === `/ayuda/${helpText.id}/${localizedSlug}` ? 'help-item active' : 'help-item'
                        }
                        to={`/${assignedLibrary}/ayuda/${helpText.id}/${localizedSlug || ''}`}
                        key={`ayuda-${index}`}
                      >
                        {localizedTitle}
                      </NavDropdown.Item>
                    );
                  })}
              </NavDropdown>
              <Dropdown.Item
                as={Link}
                to={`/${assignedLibrary}/contacto`}
                className={activeKey === '/contacto' && 'active'}
              >
                {t('contacto')}
              </Dropdown.Item>
              <Dropdown.Item
                as={Link}
                to={`/${assignedLibrary}/sobre-nosotros`}
                className={activeKey === '/sobre-nosotros' && 'active'}
              >
                {t('nosotros')}
              </Dropdown.Item>
              <Dropdown.Item
                as={Link}
                to={`/${assignedLibrary}/tarjeta-regalo`}
                className={activeKey === '/tarjeta-regalo' && 'active'}
              >
                {t('tarjetaRegalo')}
              </Dropdown.Item>
            </DropdownButton>
          )}
        </Col>
        <Col md={6} className="lang-bar d-none d-lg-block px-0 gap-3 align-items-center">
          {isWorker && (
            <div className="mr-4">
              <Button onClick={handleAdminRedirect}>{t('panelAdministracion')}</Button>
            </div>
          )}
          <div className="d-none d-lg-block">
            <LanguageSwitcher className="lang-select-desktop" dataTestId="language switcher desktop" />
          </div>
        </Col>
      </div>
    </div>
  );
};

NavBarSecondary.propTypes = {
  isSticky: PropTypes.bool,
  isDesktop: PropTypes.bool,
  activeKey: PropTypes.string,
};

export default NavBarSecondary;
